import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Marcador } from './mapas/modelos/Marcador';
import { Punto } from './mapas/modelos/Punto';
import { CroquisSizeConfig } from './mapas/modelos/CroquisSizeConfig';
import { BusquedaEstructuradaNominatim } from './mapas/modelos/BusquedaEstructuradaNominatim';
import { RespuestaNominatim } from './mapas/modelos/RespuestaNominatim';
import { EvkMapasService } from './evk-mapas.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EvkMapaComponent } from "./mapas/evk-mapa/evk-mapa.component";
import { FeatureCollection } from "geojson";

@Component({
  selector: 'evk-mapas',
  templateUrl: './evk-mapas.component.html',
  styleUrls: ['./evk-mapas.component.scss']
})
export class EvkMapasComponent implements OnInit {
  @ViewChild(EvkMapaComponent, { static: false })
  private mapaComponent: EvkMapaComponent;


  constructor(private busquedaService: EvkMapasService, private mapaService: EvkMapasService) {
  }

  ngOnInit() {
  }

  public parentEventClickEnMapa($event: any) {
    let p = new Punto($event.latitud, $event.longitud);
  }

  public obtenerImagenDeMapaComoPng(size: CroquisSizeConfig) {
    return this.mapaComponent.obtenerImagenDeMapaComoPng(size);
  }

  public buscarPuntoEnElMapa(busqueda: BusquedaEstructuradaNominatim): Observable<Punto | undefined> {
    return this.busquedaService.busquedaEstructurada<Array<RespuestaNominatim>>(busqueda)
      .pipe(
        map(data => {
          let punto;
          if (Array.isArray(data) && data.length) {
            let primerResultado = data[0];
            let latitud = parseFloat(primerResultado.lat);
            let longitud = parseFloat(primerResultado.lon);
            punto = new Punto(latitud, longitud);
          }
          return punto;
        }
        ));
  }

  public buscarPuntoEnElMapaConBusquedaSimple(busqueda: BusquedaEstructuradaNominatim): Observable<FeatureCollection | undefined> {
    return this.busquedaService.busquedaSimple<FeatureCollection>(busqueda)
      .pipe(
        map((data) => {
          if (data && Array.isArray(data.features) && data.features.length > 0) {
            //const boundaries = data.features.filter((feature) => feature.properties.category === 'boundary');
            //const boundary = boundaries.length > 0 ? boundaries[0] : undefined;
            const places = data.features.filter((feature) => feature.properties.category === 'place');
            const place = places.length > 0 ? places[0] : undefined;
            data.features = [];
            if (place) {
              place.properties.nominatim_place_id = place.properties.place_id;
              place.properties.place_id = new Date().getTime();
              data.features.push(place);
            }
            // }else if (boundary) {
            //   data.features.push(boundary);
            // }
            return data;
          }
          return undefined;
        }
        ));
  }

  public buscarPuntoEnElMapaConBusquedaEnReversa(latitud: number, longitud: number): any {
    return this.busquedaService.busquedaEnReversa<any>(latitud, longitud)
      .pipe(
        map((data) => {
          if (data && Array.isArray(data.features) && data.features.length > 0) {
            const places = data.features.filter((feature) => feature.properties.category === 'place');
            const place = places.length > 0 ? places[0] : undefined;
            data.features = [];
            if (place) {
              place.properties.nominatim_place_id = place.properties.place_id;
              place.properties.place_id = new Date().getTime();
              data.features.push(place);
            } else {
              data.features.push(this.createCustomPoint(latitud, longitud));
            }
          } else {
            data = {
              "features": [
                this.createCustomPoint(latitud, longitud)
              ],
              "type": "FeatureCollection"
            }
          }
          return data;
        }
        )
      );
  }

  public localizarPuntoEnElMapa(punto: Punto, limpiarCapas: boolean = true) {
    const features = Marcador.generaJsonMarcador(punto)
    this.agregarGeoJsonFeatures(features, limpiarCapas);
    this.mapaComponent.moverAPuntoConZoom(punto, 17);
    return features;
  }

  public actualizarPuntoDeMarcadorEnElMapa(marcador: Marcador, nuevoPunto: Punto) {
    this.mapaComponent.actualizarPuntoDeMarcador(marcador, nuevoPunto);
  }

  public moverMapaAPunto(nuevoCentro: Punto) {
    this.mapaComponent.moverAPuntoConZoom(nuevoCentro, 17);
  }

  public moverMapaAPuntoConZoom(nuevoCentro: Punto, zoom: number) {
    this.mapaComponent.moverAPuntoConZoom(nuevoCentro, zoom);
  }

  public getPosicionDeMarcador(marcador: Marcador): Punto | null {
    return this.mapaComponent.getPosicionDeMarcador(marcador);
  }

  public agregarGeoJsonFeatures(features: any, limpiarCapas: boolean = true) {
    if(limpiarCapas){
      this.mapaService.quitarTodasLasLayers();
    }
    return this.mapaService.agregarFeature(features);
  }

  public eliminarMarcador(capa): any {
    this.mapaService.quitarLayerMarker(capa);
  }

  public limpiarMapa(): any {
    this.mapaService.quitarTodasLasLayers();
  }

  public featuresToPoint(features: FeatureCollection): Punto | undefined {
    let points = features.features.filter((feature) => feature.geometry.type === 'Point');
    if (points && points.length > 0) {
      return new Punto(points[0].geometry['coordinates'][1], points[0].geometry['coordinates'][0])
    }
    points = features.features.filter((feature) => feature.geometry.type === 'LineString');
    if (points && points.length > 0) {
      return new Punto(points[0].geometry['coordinates'][1], points[0].geometry['coordinates'][0])
    }
    return undefined;
  }

  private createCustomPoint(latitud, longitud) {
    const id = new Date().getTime();
    return {
        "type": "Feature",
        "properties": {
          "place_id": id,
          "osm_type": "node",
          "osm_id": id,
          "display_name": "Sin información",
          "category": "place",
          "type": "custom"
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            longitud.toString(),
            latitud.toString()
          ]
        }
      };
  }

    public agregarMarker(marcador: Marcador){
        this.mapaComponent.agregarMarcador(marcador);
    }

}
